import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { classNamesConfig } from "../../../Shared/features/classnames";
import { slugify } from "../../../Shared/utils/string";
import { Block } from "./library/container";
export const HighlightBlock = (p)=>{
    const classNames = classNamesConfig().text;
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: `highlight ${classNames.block}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `highlight__inner ${classNames.inner}`,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        "data-anchor": slugify(p.title),
                        className: "highlight__title title--l",
                        children: p.title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight__subtitle text--m",
                        children: p.subtitle
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "highlight__text text--styled",
                        dangerouslySetInnerHTML: {
                            __html: p.content
                        }
                    })
                ]
            })
        })
    });
};
{}